import { css } from 'lit';

export const styles = css `
  u-menu {
    display: block;
    width: 100%;
  }
  u-menu::part(menu) {
    min-width: 100%;
    max-width: 50vw;
  }

  :host(:not([disabled])) .button {
    cursor: pointer;
  }

  .button {
    position: absolute;
    inset: 0;
    margin: 0;
    padding: 0;
    background: transparent;
    border: none;
    appearance: none;
  }

  select {
    pointer-events: none;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list {
    width: 2px;
    height: 2px;
    margin: -1px;
    overflow: hidden;
  }
`;
